// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10pKv","left":"styles_left__Yyltu","desktopActions":"styles_desktopActions__3U-BR","title":"styles_title__IKWhG"};